module.exports = __webpack_public_path__ + "static/media/stepper-customize-active.84a8ae05.svg";